import { FunctionComponent } from 'react';
import { BulkStatusUpdateStep } from '../../../reducers/compoundManagementSlice';
import { BulkStatusUpdateValidationFeedback } from './BulkStatusUpdateValidationFeedback';
import { BulkStatusUpdateForm } from './BulkStatusUpdateForm';
import { BulkStatusUpdateReview } from './BulkStatusUpdateReview';

interface BulkStatusUpdateDialogBodyProps {
    currentStep: BulkStatusUpdateStep;
    isProcessing: boolean;
    formProps: any;
}

export const BulkStatusUpdateDialogBody: FunctionComponent<BulkStatusUpdateDialogBodyProps> = ({
    currentStep,
    isProcessing,
    formProps,
}) => {
    switch (currentStep) {
        case BulkStatusUpdateStep.VALIDATION:
            return <BulkStatusUpdateValidationFeedback />;
        case BulkStatusUpdateStep.REVIEW_TABLE:
            return <BulkStatusUpdateReview />;
        case BulkStatusUpdateStep.FORM:
            return <BulkStatusUpdateForm disabled={isProcessing} {...formProps} />;
        default:
            return <></>;
    }
};
